import RavenWebManager from 'components/RavenWebSDK'
import { isUserSignedIn } from './browserHelper'
import { dayDiff, getFormattedDate } from 'utils/dateHelper'

export const stringifyPayload = (payload) => {
    const keys = Object.keys(payload)
    keys.forEach(key => {
        if(key === "a_fare_price" || key === "a_ct_discount" || key === "supercoin_balance" || key === "supercoin_earned" || key === "supercoin_burnt" || key === "wallet_balance_used" || key === "convenience_fee" ) payload[key] = Number(payload[key])
        else payload[key] = "" + payload[key]
    })
    return payload
}

export const ravenSDKTrigger = (eventName, ravenPayload) => {
    const commonPayload = {
        platform: 'desktop',
        login_status: isUserSignedIn() ? 'yes' : 'no',
        domain: window.location.host,
        vertical: 'air'
    }
    const newRavenPayload = stringifyPayload(ravenPayload)
    RavenWebManager.event(eventName, { ...newRavenPayload, ...commonPayload })
}

export const ravenSDKItinTrigger = (eventName, ItineraryData , additionpayload) => {
    const flightNumbers = []
    const airlineNames = []
    if(ItineraryData?.flights){
    ItineraryData.flights.forEach(flight =>
        flight.segments.forEach(segment => {
            flightNumbers.push(segment.airline + '-' + segment.flightNumber)
            airlineNames.push(segment.airlineName)
        })
    )
    let flightNumbersValue = flightNumbers.length > 1 ? flightNumbers.join(',') : flightNumbers[0]
    let airlineNameValue = airlineNames.length > 1 ? airlineNames.join(',') : airlineNames[0]
    const commonItinPayload = {
        a_trip_type: ItineraryData?.searchCriteria?.international ? 'international' : 'domestic',
        a_journey_type: ItineraryData?.searchCriteria?.arrivalDate ? 'rt' : 'ow',
        a_origin: ItineraryData?.searchCriteria?.from || 'N/A',
        a_itinerary_id: ItineraryData?.itineraryId || 'N/A',
        a_destination: ItineraryData?.searchCriteria?.to || 'N/A',
        a_airline: airlineNameValue,
        a_flight_number: flightNumbersValue
    }
    ravenSDKTrigger(eventName , {...additionpayload , ...commonItinPayload})
    }
}

export const ravenSDKItinPageLoad = ({ eventName, ItineraryData, initialTS, ...additionpayload }) => {
    if (ItineraryData?.flights) {
        const pageLoadPayLoad = {
            a_utm_source: ItineraryData?.meta?.utmSource || 'organic',
            page_loadtime: initialTS ? new Date().getTime() - initialTS : 'N/A',
            a_search_id: ItineraryData?.meta?.sid || 'N/A',
            a_return_date: ItineraryData?.searchCriteria?.arrivalDate ? getFormattedDate(ItineraryData?.searchCriteria?.arrivalDate, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ') : 'NA',
            a_stop_count_onward_return : ItineraryData?.flights?.[1]?.stopCount || ItineraryData?.flights?.[1]?.stopCount === 0  ?  ItineraryData?.flights?.[0]?.stopCount  + ',' + ItineraryData?.flights?.[1]?.stopCount : ItineraryData?.flights?.[0]?.stopCount + '',
            a_dx: dayDiff(new Date(ItineraryData?.searchCriteria?.departDate), new Date()),
            a_adult_count: ItineraryData?.searchCriteria?.paxInfo?.adults || 0,
            a_fare_type: ItineraryData?.searchCriteria?.sft || 'regular',
            a_child_count: ItineraryData?.searchCriteria?.paxInfo?.children || 0,
            a_infant_count: ItineraryData?.searchCriteria?.paxInfo?.infants || 0,
            a_departure_date: getFormattedDate(ItineraryData?.searchCriteria?.departDate, 'DD/MM/YYYY', 'YYYY-MM-DDTHH:mm:ssZ')
        }
        ravenSDKItinTrigger(eventName , ItineraryData, { ...pageLoadPayLoad, ...additionpayload })
    }
}
